import { render, staticRenderFns } from "./StockInLogView.vue?vue&type=template&id=45a5e5ba&scoped=true"
import script from "./StockInLogView.vue?vue&type=script&lang=js"
export * from "./StockInLogView.vue?vue&type=script&lang=js"
import style0 from "./StockInLogView.vue?vue&type=style&index=0&id=45a5e5ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a5e5ba",
  null
  
)

export default component.exports